<template>
  <ui-overlay-loader :loading="isPoaUpdating || actionInProgress">
    <ui-heading tag="h3" no-top-margin>
      {{ $t("additional_documents.title") }}
    </ui-heading>
    <document-preview-container
      :is-updating="isPoaUpdating || actionInProgress"
      :document-type="MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_TIN"
      :title="$t('additional_documents.taxIdentificationNumber.title')"
    />
    <document-preview-container
      :is-updating="isPoaUpdating || actionInProgress"
      :document-type="MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_VAT"
      :title="$t('additional_documents.vatNumber.title')"
    />
    <document-preview-container
      :is-updating="isPoaUpdating || actionInProgress"
      :document-type="MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_CRN"
      :title="$t('additional_documents.companyRegNumber.title')"
    />
    <document-preview-container
      :is-updating="isPoaUpdating || actionInProgress"
      :document-type="MEDIA_ADDITIONAL_DOCUMENT_TYPE.PROOF_OF_POB"
      :title="$t('additional_documents.placeOfBirth.title')"
    />
    <proof-of-address
      :is-updating="isPoaUpdating || actionInProgress"
      :complianceReviewIdentificationId="complianceReviewIdentificationId"
    />
  </ui-overlay-loader>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";
import { MEDIA_ADDITIONAL_DOCUMENT_TYPE } from "../../constants";
import ProofOfAddress from "./ProofOfAddress.vue";
import DocumentPreviewContainer from "./DocumentPreviewContainer.vue";

export default {
  props: {
    complianceReviewIdentificationId: { type: String, default: null }
  },

  data() {
    return { MEDIA_ADDITIONAL_DOCUMENT_TYPE };
  },

  computed: {
    ...mapGetters([getters.actionInProgress, getters.isPoaUpdating])
  },

  components: {
    ProofOfAddress,
    DocumentPreviewContainer
  }
};
</script>
